export interface EntryTimelineItem {
  date: string;
  title: string;
  desc: string;
}

export interface EntryBasicItem {
  label: string;
  value: string;
}

export interface Entry {
  id: string;
  name: string;
  alias: string;
  title: string;
  categoryId: string;
  cover: string;
  avatar: string;
  hot: number;
  status: string;
  updatedAt: string;
  publishedAt: string;
  tags: string[];
  summary: string;
  intro: string;
  basicInfo: EntryBasicItem[];
  timeline: EntryTimelineItem[];
  relatedIds: string[];
}

export const entries: Entry[] = [
  {
    id: "lin-yichen",
    name: "林逸辰",
    alias: "青年演员 · 都市剧",
    title: "林逸辰 · 深夜聚会风波",
    categoryId: "star",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20entertainment%20magazine%20scene%20of%20a%20young%20male%20actor%20leaving%20a%20modern%20city%20venue%20at%20night%2C%20warm%20amber%20and%20crimson%20rim%20lighting%2C%20dark%20charcoal%20backdrop%2C%20cinematic%20soft%20shadows%2C%20shallow%20depth%20of%20field%2C%20moody%20atmosphere%2C%20professional%20photography&width=800&height=600&seq=cover-lin-yichen&orientation=landscape",
    avatar:
      "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20young%20man%20with%20short%20black%20hair%20in%20a%20minimal%20dark%20jacket%2C%20warm%20amber%20rim%20light%2C%20plain%20dark%20charcoal%20backdrop%2C%20soft%20cinematic%20shadows%2C%20high%20detail%2C%20editorial%20magazine%20photography&width=400&height=400&seq=face-lin-yichen&orientation=squarish",
    hot: 9860,
    status: "持续发酵",
    updatedAt: "2026-09-11",
    publishedAt: "2026-08-12",
    tags: ["深夜聚会", "跟拍视频", "工作室回应"],
    summary:
      "一段深夜聚会的路人视频在网络流传，围绕同行人员身份与现场细节的讨论持续升温，其工作室随后发布了简短说明。",
    intro:
      "林逸辰是本词条设定中的青年演员，凭借两部都市剧进入大众视野。本词条只整理该话题在公开渠道出现过的信息脉络，包括视频出现、讨论扩散、工作室发声三个节点，方便读者快速了解前后顺序，不做任何未公开信息的推断。",
    basicInfo: [
      { label: "人物设定", value: "青年演员 / 都市剧" },
      { label: "话题标签", value: "深夜聚会" },
      { label: "首次出现", value: "2026-08-12" },
      { label: "当前状态", value: "持续发酵" },
      { label: "主要来源", value: "社交平台、短视频平台" },
    ],
    timeline: [
      {
        date: "2026-08-12",
        title: "路人视频出现",
        desc: "一段记录夜间街景的短视频被上传，画面中出现了疑似同一行程的多位同行人员，短时间内被大量转发。",
      },
      {
        date: "2026-08-14",
        title: "讨论快速扩散",
        desc: "相关话题进入热榜，网友围绕同行人员身份展开比对与讨论，出现多个不同版本的解读。",
      },
      {
        date: "2026-08-17",
        title: "工作室简短说明",
        desc: "其工作室发布一段简短文字，说明当天为常规朋友聚会，希望外界不要过度关联无关人员。",
      },
      {
        date: "2026-09-11",
        title: "话题进入长尾期",
        desc: "讨论热度回落，但仍有零散补充内容出现，词条更新至最新公开信息。",
      },
    ],
    relatedIds: ["su-wanqing", "gu-xingchen"],
  },
  {
    id: "su-wanqing",
    name: "苏晚晴",
    alias: "演员 · 时尚合作",
    title: "苏晚晴 · 代言解约传闻",
    categoryId: "star",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20fashion%20magazine%20scene%20with%20a%20female%20actress%20walking%20through%20a%20warmly%20lit%20studio%20corridor%2C%20amber%20and%20deep%20red%20tones%2C%20dark%20taupe%20backdrop%2C%20cinematic%20soft%20shadows%2C%20shallow%20depth%20of%20field%2C%20moody%20elegant%20atmosphere%2C%20professional%20photography&width=800&height=600&seq=cover-su-wanqing&orientation=landscape",
    avatar:
      "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20young%20woman%20with%20long%20dark%20hair%20wearing%20a%20minimal%20warm%20beige%20blazer%2C%20soft%20amber%20rim%20light%2C%20plain%20dark%20taupe%20backdrop%2C%20gentle%20cinematic%20shadows%2C%20high%20detail%2C%20editorial%20photography&width=400&height=400&seq=face-su-wanqing&orientation=squarish",
    hot: 8420,
    status: "已回应",
    updatedAt: "2026-09-09",
    publishedAt: "2026-08-05",
    tags: ["代言变动", "品牌物料", "官方回应"],
    summary:
      "品牌方更新了合作页面中的物料排列，外界由此推测代言关系发生变化，随后双方分别以不同方式作出说明。",
    intro:
      "苏晚晴在本站设定中是一位以时尚造型见长的演员。该词条关注的是品牌页面物料调整引发的猜测，这类话题往往由细节变化触发，本词条把可见的公开动作按时间排列，帮助读者分辨「事实」与「推测」的边界。",
    basicInfo: [
      { label: "人物设定", value: "演员 / 时尚领域" },
      { label: "话题标签", value: "代言变动" },
      { label: "首次出现", value: "2026-08-05" },
      { label: "当前状态", value: "已回应" },
      { label: "主要来源", value: "品牌官方页面、社交平台" },
    ],
    timeline: [
      {
        date: "2026-08-05",
        title: "合作页面调整",
        desc: "有网友发现品牌合作专区的人物物料顺序发生变化，随即出现关于合作状态的猜测。",
      },
      {
        date: "2026-08-08",
        title: "多方解读出现",
        desc: "不同账号给出互相矛盾的说法，缺少可核实的公开依据，讨论集中在页面截图本身。",
      },
      {
        date: "2026-08-19",
        title: "品牌方说明",
        desc: "品牌方在社媒回复中表示页面更新属于常规排期调整，与艺人合作状态无关。",
      },
      {
        date: "2026-09-09",
        title: "话题趋于平息",
        desc: "相关讨论热度下降，词条标记为已回应并保留完整时间线。",
      },
    ],
    relatedIds: ["lin-yichen", "shen-mobai"],
  },
  {
    id: "cheng-yirou",
    name: "程亦柔",
    alias: "内容创作者 · 直播间",
    title: "程亦柔 · 直播片段被二次剪辑",
    categoryId: "creator",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20scene%20of%20a%20streaming%20room%20set%20with%20ring%20lights%20and%20monitors%2C%20warm%20amber%20glow%20against%20dark%20charcoal%20walls%2C%20cinematic%20soft%20shadows%2C%20shallow%20depth%20of%20field%2C%20moody%20modern%20atmosphere%2C%20professional%20photography&width=800&height=600&seq=cover-cheng-yirou&orientation=landscape",
    avatar:
      "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20young%20woman%20with%20shoulder%20length%20hair%20and%20a%20warm%20knit%20top%2C%20amber%20rim%20light%2C%20plain%20dark%20backdrop%2C%20soft%20cinematic%20shadows%2C%20high%20detail%2C%20editorial%20magazine%20photography&width=400&height=400&seq=face-cheng-yirou&orientation=squarish",
    hot: 7310,
    status: "持续发酵",
    updatedAt: "2026-09-10",
    publishedAt: "2026-08-22",
    tags: ["直播片段", "二次剪辑", "澄清说明"],
    summary:
      "一段直播回放被截取成短片段传播，脱离原语境后引发误读，创作者在后续直播中还原了完整表述。",
    intro:
      "程亦柔是本站设定中的内容创作者，以生活分享和长时段直播为主要形式。该话题的典型特征是「切片传播」——同一段话在不同语境下会被读出完全不同的意思，因此本词条同时保留了片段与原直播时间点。",
    basicInfo: [
      { label: "人物设定", value: "内容创作者 / 主播" },
      { label: "话题标签", value: "片段剪辑" },
      { label: "首次出现", value: "2026-08-22" },
      { label: "当前状态", value: "持续发酵" },
      { label: "主要来源", value: "短视频平台" },
    ],
    timeline: [
      {
        date: "2026-08-22",
        title: "切片开始传播",
        desc: "一段约二十秒的直播片段被多个账号转发，评论区出现大量不同理解。",
      },
      {
        date: "2026-08-25",
        title: "原片段被找回",
        desc: "有观众贴出完整回放位置，显示被截取话语前后存在限定条件，讨论出现转折。",
      },
      {
        date: "2026-08-29",
        title: "直播中还原语境",
        desc: "创作者在直播中重述当时的完整表达，并展示了当天的直播记录。",
      },
      {
        date: "2026-09-10",
        title: "切片仍在流转",
        desc: "部分旧切片仍在被转发，词条持续跟进更新。",
      },
    ],
    relatedIds: ["bai-ruoxi", "lin-yichen"],
  },
  {
    id: "lu-jingheng",
    name: "陆景珩",
    alias: "演员 · 古装剧",
    title: "陆景珩 · 选角争议梳理",
    categoryId: "screen",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20scene%20of%20a%20traditional%20chinese%20film%20set%20with%20wooden%20props%20and%20warm%20lantern%20light%2C%20amber%20and%20deep%20red%20tones%20against%20dark%20brown%20backdrop%2C%20cinematic%20soft%20shadows%2C%20shallow%20depth%20of%20field%2C%20moody%20atmosphere&width=800&height=600&seq=cover-lu-jingheng&orientation=landscape",
    avatar:
      "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20man%20with%20tied%20back%20dark%20hair%20wearing%20a%20simple%20dark%20collarless%20shirt%2C%20warm%20amber%20rim%20light%2C%20plain%20dark%20brown%20backdrop%2C%20soft%20cinematic%20shadows%2C%20high%20detail%2C%20editorial%20photography&width=400&height=400&seq=face-lu-jingheng&orientation=squarish",
    hot: 6640,
    status: "已回应",
    updatedAt: "2026-09-07",
    publishedAt: "2026-07-28",
    tags: ["选角讨论", "番位", "剧组回应"],
    summary:
      "新剧公布主演阵容后，围绕角色适配度与番位排列的讨论集中出现，片方随后发布了角色设定说明。",
    intro:
      "陆景珩在本站设定中以古装剧作品为主。选角话题通常由官方物料公布触发，讨论会同时涉及角色设定、演员经历与排位方式，本词条将这些线索分开整理，避免混为一谈。",
    basicInfo: [
      { label: "人物设定", value: "演员 / 古装剧" },
      { label: "话题标签", value: "选角讨论" },
      { label: "首次出现", value: "2026-07-28" },
      { label: "当前状态", value: "已回应" },
      { label: "主要来源", value: "官方物料、行业媒体" },
    ],
    timeline: [
      {
        date: "2026-07-28",
        title: "阵容正式公布",
        desc: "剧集官宣主演阵容与角色海报，讨论在数小时内集中出现。",
      },
      {
        date: "2026-07-31",
        title: "番位话题升温",
        desc: "海报排版与署名顺序被反复对比，出现围绕排位的多种解读。",
      },
      {
        date: "2026-08-06",
        title: "片方发布角色说明",
        desc: "片方以图文形式说明角色设定与叙事结构，回应主要集中在适配度层面。",
      },
      {
        date: "2026-09-07",
        title: "讨论转向作品本身",
        desc: "随着预告片释出，话题重心逐步回到剧情与制作层面。",
      },
    ],
    relatedIds: ["xu-zhiyao", "jiang-yutong"],
  },
  {
    id: "jiang-yutong",
    name: "江语桐",
    alias: "艺人档案 · 出道十年",
    title: "江语桐 · 出道十年经历档案",
    categoryId: "archive",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20archive%20scene%20with%20stacked%20magazines%20and%20warm%20desk%20lamp%20light%20in%20a%20quiet%20studio%2C%20amber%20and%20brown%20tones%2C%20dark%20backdrop%2C%20cinematic%20soft%20shadows%2C%20shallow%20depth%20of%20field%2C%20reflective%20moody%20atmosphere&width=800&height=600&seq=cover-jiang-yutong&orientation=landscape",
    avatar:
      "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20woman%20with%20straight%20dark%20hair%20and%20a%20minimal%20dark%20top%2C%20soft%20warm%20rim%20light%2C%20plain%20dark%20brown%20backdrop%2C%20gentle%20cinematic%20shadows%2C%20high%20detail%2C%20editorial%20magazine%20photography&width=400&height=400&seq=face-jiang-yutong&orientation=squarish",
    hot: 5980,
    status: "趋于平息",
    updatedAt: "2026-09-05",
    publishedAt: "2026-07-16",
    tags: ["出道经历", "作品脉络", "舆情变化"],
    summary:
      "以时间为线索梳理其出道以来的作品节点与公开活动轨迹，作为理解后续各类话题的背景资料。",
    intro:
      "江语桐在本站设定中出道较早，作品跨度较大。艺人档案类词条的作用是提供背景：把作品与公开活动的顺序理清楚，读者在看待任何具体话题时都能有一个稳定的参照系，而不是被单条信息牵着走。",
    basicInfo: [
      { label: "人物设定", value: "艺人 / 多领域发展" },
      { label: "话题类型", value: "人物背景档案" },
      { label: "资料起点", value: "2016 年" },
      { label: "当前状态", value: "趋于平息" },
      { label: "主要来源", value: "公开作品与活动记录" },
    ],
    timeline: [
      {
        date: "2016-09",
        title: "正式出道",
        desc: "以组合身份参与首场公开演出，进入大众视野。",
      },
      {
        date: "2019-04",
        title: "转向影视作品",
        desc: "开始参与剧集拍摄，作品类型逐渐从青春题材扩展到现实题材。",
      },
      {
        date: "2022-11",
        title: "阶段低谷",
        desc: "作品间隔拉长，公开活动减少，出现少量关于状态与规划的猜测。",
      },
      {
        date: "2026-07",
        title: "档案更新",
        desc: "本词条补全近年作品与活动节点，形成连贯的时间线。",
      },
    ],
    relatedIds: ["wen-zimo", "lu-jingheng"],
  },
  {
    id: "shen-mobai",
    name: "沈墨白",
    alias: "演员 · 品牌合作",
    title: "沈墨白 · 广告文案争议",
    categoryId: "brand",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20scene%20of%20a%20studio%20shoot%20with%20lighting%20stands%20and%20product%20display%20tables%2C%20warm%20amber%20light%20against%20dark%20charcoal%20backdrop%2C%20cinematic%20soft%20shadows%2C%20shallow%20depth%20of%20field%2C%20moody%20production%20atmosphere&width=800&height=600&seq=cover-shen-mobai&orientation=landscape",
    avatar:
      "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20man%20with%20short%20neat%20hair%20in%20a%20warm%20olive%20shirt%2C%20amber%20rim%20light%2C%20plain%20dark%20charcoal%20backdrop%2C%20soft%20cinematic%20shadows%2C%20high%20detail%2C%20editorial%20photography&width=400&height=400&seq=face-shen-mobai&orientation=squarish",
    hot: 5470,
    status: "已回应",
    updatedAt: "2026-09-03",
    publishedAt: "2026-07-09",
    tags: ["广告文案", "物料调整", "品牌回应"],
    summary:
      "合作广告中的一句文案被指表达不当，品牌方下架相关物料并致歉，艺人团队随后作出说明。",
    intro:
      "沈墨白在本站设定中商业合作较多。文案类争议的焦点通常不在人物本身，而在于制作与审核环节，本词条把物料上线、下架、说明三个动作按顺序记录，让读者清楚每一步的责任主体。",
    basicInfo: [
      { label: "人物设定", value: "演员 / 商业合作" },
      { label: "话题标签", value: "广告文案" },
      { label: "首次出现", value: "2026-07-09" },
      { label: "当前状态", value: "已回应" },
      { label: "主要来源", value: "品牌官方账号" },
    ],
    timeline: [
      {
        date: "2026-07-09",
        title: "物料上线",
        desc: "合作广告短片与平面物料同步上线，其中一句文案被指表达欠妥。",
      },
      {
        date: "2026-07-10",
        title: "讨论集中出现",
        desc: "相关截图被大量转发，讨论集中在文案审核流程上。",
      },
      {
        date: "2026-07-12",
        title: "品牌下架并致歉",
        desc: "品牌方下架相关物料并发布致歉说明，表示将复盘审核流程。",
      },
      {
        date: "2026-09-03",
        title: "话题收尾",
        desc: "艺人团队说明参与范围，事件热度回落。",
      },
    ],
    relatedIds: ["su-wanqing", "gu-xingchen"],
  },
  {
    id: "gu-xingchen",
    name: "顾星辰",
    alias: "演员 · 影视新作",
    title: "顾星辰 · 片场传闻梳理",
    categoryId: "star",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20scene%20of%20a%20film%20shoot%20at%20dusk%20with%20camera%20rigs%20and%20warm%20amber%20practical%20lights%2C%20dark%20charcoal%20backdrop%2C%20cinematic%20soft%20shadows%2C%20shallow%20depth%20of%20field%2C%20moody%20production%20atmosphere%2C%20professional%20photography&width=800&height=600&seq=cover-gu-xingchen&orientation=landscape",
    avatar:
      "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20young%20man%20with%20medium%20length%20hair%20in%20a%20simple%20dark%20coat%2C%20warm%20amber%20rim%20light%2C%20plain%20dark%20backdrop%2C%20soft%20cinematic%20shadows%2C%20high%20detail%2C%20editorial%20magazine%20photography&width=400&height=400&seq=face-gu-xingchen&orientation=squarish",
    hot: 6890,
    status: "持续发酵",
    updatedAt: "2026-09-12",
    publishedAt: "2026-08-30",
    tags: ["片场传闻", "匿名爆料", "待核实"],
    summary:
      "社交平台出现匿名账号发布片场相关说法，因缺少可核实信息，讨论迅速分为相信与质疑两派。",
    intro:
      "顾星辰在本站设定中正在拍摄新剧。涉及「匿名爆料」的话题最需要谨慎对待：没有可核实来源的说法不具备参考价值，本词条特意标注了信息可信度，并只记录能够被公开确认的部分。",
    basicInfo: [
      { label: "人物设定", value: "演员 / 影视新作" },
      { label: "话题标签", value: "片场传闻" },
      { label: "首次出现", value: "2026-08-30" },
      { label: "当前状态", value: "持续发酵" },
      { label: "信息可信度", value: "较低（匿名来源）" },
    ],
    timeline: [
      {
        date: "2026-08-30",
        title: "匿名账号发帖",
        desc: "一个无历史记录的账号发布片场相关说法，未提供任何可核实依据。",
      },
      {
        date: "2026-09-01",
        title: "讨论两极分化",
        desc: "部分网友要求提供证据，另一部分直接采信，话题进入热榜。",
      },
      {
        date: "2026-09-06",
        title: "剧组发布拍摄花絮",
        desc: "剧组释出常规花絮物料，但未直接回应传闻本身。",
      },
      {
        date: "2026-09-12",
        title: "词条标注可信度",
        desc: "本词条将信息可信度标记为较低，并提醒读者谨慎判断。",
      },
    ],
    relatedIds: ["lin-yichen", "shen-mobai"],
  },
  {
    id: "bai-ruoxi",
    name: "白若曦",
    alias: "内容创作者 · 形象话题",
    title: "白若曦 · 形象讨论与回应",
    categoryId: "creator",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20scene%20of%20a%20soft%20lit%20vanity%20table%20with%20mirrors%20and%20warm%20bulbs%2C%20amber%20and%20muted%20rose%20tones%20against%20dark%20backdrop%2C%20cinematic%20soft%20shadows%2C%20shallow%20depth%20of%20field%2C%20moody%20atmosphere%2C%20professional%20photography&width=800&height=600&seq=cover-bai-ruoxi&orientation=landscape",
    avatar:
      "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20young%20woman%20with%20soft%20wavy%20dark%20hair%20and%20a%20warm%20cream%20blouse%2C%20amber%20rim%20light%2C%20plain%20muted%20dark%20backdrop%2C%20gentle%20cinematic%20shadows%2C%20high%20detail%2C%20editorial%20beauty%20photography&width=400&height=400&seq=face-bai-ruoxi&orientation=squarish",
    hot: 5120,
    status: "已回应",
    updatedAt: "2026-09-04",
    publishedAt: "2026-08-18",
    tags: ["线下活动", "形象讨论", "本人回应"],
    summary:
      "线下活动路透照片与日常内容中的呈现差异引发讨论，创作者以轻松方式作出回应。",
    intro:
      "白若曦在本站设定中主攻生活方式内容。围绕「镜头呈现」的讨论在创作者群体中很常见，本词条把它当作一次关于内容行业的公开讨论来记录，而不是对个人外形的评价。",
    basicInfo: [
      { label: "人物设定", value: "内容创作者 / 生活方式" },
      { label: "话题标签", value: "形象讨论" },
      { label: "首次出现", value: "2026-08-18" },
      { label: "当前状态", value: "已回应" },
      { label: "主要来源", value: "线下活动路透、社交平台" },
    ],
    timeline: [
      {
        date: "2026-08-18",
        title: "活动路透出现",
        desc: "线下活动照片被上传，与日常内容中的呈现方式存在明显差异。",
      },
      {
        date: "2026-08-21",
        title: "讨论扩展到行业层面",
        desc: "话题从个人延伸到拍摄手法、滤镜使用等更普遍的行业讨论。",
      },
      {
        date: "2026-08-24",
        title: "本人轻松回应",
        desc: "她在评论区以自嘲方式回应，并补充说明拍摄环境与光线的影响。",
      },
      {
        date: "2026-09-04",
        title: "话题平稳结束",
        desc: "讨论热度自然下降，词条标记为已回应。",
      },
    ],
    relatedIds: ["cheng-yirou"],
  },
  {
    id: "wen-zimo",
    name: "温子墨",
    alias: "艺人 · 沉寂后回归",
    title: "温子墨 · 沉寂两年后回归",
    categoryId: "comeback",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20scene%20of%20an%20empty%20rehearsal%20room%20with%20wooden%20floor%20and%20warm%20window%20light%2C%20amber%20and%20deep%20brown%20tones%20against%20dark%20backdrop%2C%20cinematic%20soft%20shadows%2C%20shallow%20depth%20of%20field%2C%20reflective%20moody%20atmosphere&width=800&height=600&seq=cover-wen-zimo&orientation=landscape",
    avatar:
      "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20man%20with%20short%20dark%20hair%20in%20a%20simple%20charcoal%20sweater%2C%20soft%20amber%20rim%20light%2C%20plain%20dark%20brown%20backdrop%2C%20gentle%20cinematic%20shadows%2C%20high%20detail%2C%20editorial%20magazine%20photography&width=400&height=400&seq=face-wen-zimo&orientation=squarish",
    hot: 4760,
    status: "趋于平息",
    updatedAt: "2026-09-02",
    publishedAt: "2026-08-01",
    tags: ["复出动态", "澄清说明", "作品预告"],
    summary:
      "结束约两年的低曝光期后，其团队发布长文说明近况，并公布后续作品计划，回应了此前的多项猜测。",
    intro:
      "温子墨在本站设定中曾短暂淡出公众视野。复出类词条的价值在于把「沉寂期发生了什么」与「本人如何说明」对应起来，减少猜测空间，也让时间线本身成为最直接的参考。",
    basicInfo: [
      { label: "人物设定", value: "艺人 / 影视与舞台" },
      { label: "话题标签", value: "复出与澄清" },
      { label: "首次出现", value: "2026-08-01" },
      { label: "当前状态", value: "趋于平息" },
      { label: "主要来源", value: "本人及团队公开说明" },
    ],
    timeline: [
      {
        date: "2024-06",
        title: "公开活动减少",
        desc: "作品与活动记录明显减少，进入约两年的低曝光阶段。",
      },
      {
        date: "2026-08-01",
        title: "团队发布长文",
        desc: "团队说明近况，回应此前流传的多项猜测，并感谢外界等待。",
      },
      {
        date: "2026-08-15",
        title: "公布作品计划",
        desc: "宣布将参与新项目，并释出概念物料。",
      },
      {
        date: "2026-09-02",
        title: "话题平稳收束",
        desc: "讨论重心转向对新作品的期待，词条更新完毕。",
      },
    ],
    relatedIds: ["jiang-yutong"],
  },
  {
    id: "xu-zhiyao",
    name: "许知遥",
    alias: "演员 · 现代剧",
    title: "许知遥 · 番位与署名排序讨论",
    categoryId: "screen",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20scene%20of%20a%20modern%20production%20office%20wall%20with%20printed%20posters%20and%20warm%20task%20lighting%2C%20amber%20and%20deep%20red%20tones%20against%20dark%20taupe%20backdrop%2C%20cinematic%20soft%20shadows%2C%20shallow%20depth%20of%20field%2C%20moody%20atmosphere&width=800&height=600&seq=cover-xu-zhiyao&orientation=landscape",
    avatar:
      "https://readdy.ai/api/search-image?query=studio%20portrait%20of%20a%20woman%20with%20tied%20back%20dark%20hair%20in%20a%20minimal%20dark%20blazer%2C%20warm%20amber%20rim%20light%2C%20plain%20dark%20taupe%20backdrop%2C%20soft%20cinematic%20shadows%2C%20high%20detail%2C%20editorial%20photography&width=400&height=400&seq=face-xu-zhiyao&orientation=squarish",
    hot: 4410,
    status: "已回应",
    updatedAt: "2026-08-28",
    publishedAt: "2026-07-21",
    tags: ["署名排序", "官方海报", "联合说明"],
    summary:
      "剧集海报与片头中的署名顺序引发讨论，制作方随后发布联合说明，明确了排序依据。",
    intro:
      "许知遥在本站设定中作品以现代剧为主。署名排序属于行业内长期存在的讨论点，本词条把海报发布、片头释出、官方说明三个环节分开记录，让读者看清争议的具体落点。",
    basicInfo: [
      { label: "人物设定", value: "演员 / 现代剧" },
      { label: "话题标签", value: "署名排序" },
      { label: "首次出现", value: "2026-07-21" },
      { label: "当前状态", value: "已回应" },
      { label: "主要来源", value: "官方海报、片头物料" },
    ],
    timeline: [
      {
        date: "2026-07-21",
        title: "主海报发布",
        desc: "官方发布主视觉海报，署名排列方式被快速放大讨论。",
      },
      {
        date: "2026-07-24",
        title: "片头物料释出",
        desc: "片头画面公开后，讨论从海报延伸到片头排序规则。",
      },
      {
        date: "2026-07-30",
        title: "制作方联合说明",
        desc: "制作方与发行方共同说明排序依据，强调与角色权重无关。",
      },
      {
        date: "2026-08-28",
        title: "话题结束",
        desc: "讨论热度回落，词条保留完整记录。",
      },
    ],
    relatedIds: ["lu-jingheng"],
  },
];